// extracted by mini-css-extract-plugin
export default {"footerAction":"DesignNameModal_footerAction__FEp+6","container":"DesignNameModal_container__8hgIo"};